import {Component, EventEmitter, Input, Output,} from '@angular/core';
import {Amount} from "../../../../../../open-api-generated/models/amount";

@Component({
  selector: 'app-shipment-amount-view-component',
  templateUrl: './amount-view.component.html',
  styleUrls: ['./amount-view.component.scss']
})
export class AmountViewComponent {
  @Input('currency') currency: string
  @Input('amount') amount: Amount|null;
  @Input('name') name: string;
}
